import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import TankerIndex from './TankerIndex';
import TankerSettings from './TankerSettings';
import TankerUsers from './TankerUsers';
import TankerPricing from './TankerPricing';
import TankerTransactions from './TankerTransactions';
import TankerVehicles from './TankerVehicles';
import TankerPermits from './TankerPermits';
import TankerReports from './TankerReports';

function Tanker() {
  return (
    <Routes>
      <Route path="/" element={<TankerTransactions />} />
      <Route path="/dashboard" element={<TankerIndex />} />
      <Route path="/transactions" element={<TankerTransactions />} />
      <Route path="/vehicles" element={<TankerVehicles />} />
      <Route path="/permits" element={<TankerPermits />} />
      <Route path="/users" element={<TankerUsers />} />
      <Route path="/pricing" element={<TankerPricing />} />
      <Route path="/settings" element={<TankerSettings />} />
      <Route path="/reports" element={<TankerReports />} />
      <Route path="*" element={<Navigate to="/tanker" replace />} />
    </Routes>
  );
}

export default Tanker; 